<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心</el-breadcrumb-item
        >
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/baseContent/navigationInfo' }"
          >栏目列表</el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><span class="text-primary">编辑栏目</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>

    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">编辑栏目</span>
      </div>
      <div
        style="height: 470px;overflow-y: auto;padding-right: 60px"
        v-loading="loading"
      >
        <el-form
          label-width="120px"
          class="font-weight-bold"
          :model="navigationInfo"
        >
          <el-form-item label="栏目名称">
            <el-input v-model="navigationInfo.navName"></el-input>
          </el-form-item>
          <el-form-item label="栏目副标题">
            <el-input v-model="navigationInfo.subTitle"></el-input>
          </el-form-item>
          <el-form-item label="导航顺序">
            <el-input v-model="navigationInfo.navOrder"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-radio-group v-model="navigationInfo.navStatus">
              <el-radio :label="true" border>启用</el-radio>
              <el-radio :label="false" border>禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="主标题图片"
            v-if="navId !== 1 && navId !== 6 && navId !== 7 && navId !== 8"
          >
            <el-input
              v-model="navigationInfo.titleImg"
              autocomplete="off"
              placeholder="主标题图片 URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(1)"
                ref="titleImgUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸50*50像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail"
                :src="navigationInfo.titleImg"
                :preview-src-list="[navigationInfo.titleImg]"
                alt="主标题图片"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="查看更多图片"
            v-if="navId !== 1 && navId !== 6 && navId !== 7 && navId !== 8"
          >
            <el-input
              v-model="navigationInfo.moreImgUrl"
              autocomplete="off"
              placeholder="查看更多图片 URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(2)"
                ref="moreImgUrlUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸40*40像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail"
                :src="navigationInfo.moreImgUrl"
                :preview-src-list="[navigationInfo.moreImgUrl]"
                alt="查看更多图片"
              />
            </div>
          </el-form-item>
          <el-form-item label="页面头部大图" v-if="navId !== 1">
            <el-input
              v-model="navigationInfo.bannerImg"
              autocomplete="off"
              placeholder="页面头部大图 URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(3)"
                ref="bannerImgUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸1550*240像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail"
                width="800"
                :src="navigationInfo.bannerImg"
                :preview-src-list="[navigationInfo.bannerImg]"
                alt="页面头部大图"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitNavigationInfoForm(navigationInfo)"
              >立即修改</el-button
            >
            <el-button @click="findNavigationById()">重置 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import ImgUpload from "../../components/common/ImgUpload";
export default {
  name: "EditNavigation",
  data() {
    return {
      navId: this.$route.params.navId,
      navigationInfo: {
        titleImg: "",
        moreImgUrl: "",
        bannerImg: ""
      },
      loading: false
    };
  },
  components: {
    ImgUpload
  },
  mounted() {
    this.findNavigationById();
  },
  methods: {
    uploadImg(value) {
      if (value === 1) {
        this.navigationInfo.titleImg = this.$refs.titleImgUpload.url;
      }
      if (value === 2) {
        this.navigationInfo.moreImgUrl = this.$refs.moreImgUrlUpload.url;
      }
      if (value === 3) {
        this.navigationInfo.bannerImg = this.$refs.bannerImgUpload.url;
      }
    },
    submitNavigationInfoForm(navigationInfo) {
      this.axios
        .post("/navigation/admin/updateNavigation", {
          navId: navigationInfo.navId,
          navName: navigationInfo.navName,
          titleImg: navigationInfo.titleImg,
          bannerImg: navigationInfo.bannerImg,
          subTitle: navigationInfo.subTitle,
          navOrder: navigationInfo.navOrder,
          navStatus: navigationInfo.navStatus,
          moreImgUrl: navigationInfo.moreImgUrl
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "NavigationInfo" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    },
    findNavigationById() {
      this.loading = true;
      this.axios
        .get("/navigation/findNavigationById", {
          params: {
            navId: this.navId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.navigationInfo = resp.data.data;
            this.loading = false;
          }
        });
    }
  }
};
</script>

<style scoped></style>
